export const idPrefix = 'NEWTEMPID';
export const getId = array => idPrefix + array.length;
export const isNew = id => id === undefined || id.includes(idPrefix);
